import { HttpClient } from '@angular/common/http';
import { PatientsService } from './../patients.service';
import { Component, OnInit,Output,Input,EventEmitter, OnDestroy } from '@angular/core';
import { Subscription, Subject ,timer, BehaviorSubject } from 'rxjs';
import { pairwise, skip, switchMap, takeUntil } from 'rxjs/operators';
import { Router } from '@angular/router';
import { LoginService } from '../login.service';
import { TranslateService } from '@ngx-translate/core';
import { MessagingAppDialogComponent } from '../messaging-app-dialog/messaging-app-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { WhatsappService } from '../whatsapp.service';
import { msgAppAccessService } from '../msgappaccess.service';
@Component({
    selector: 'app-bar',
    templateUrl: './bar.component.html',
    styleUrls: ['./bar.component.scss'],
    standalone: false
})
export class BarComponent implements OnInit,OnDestroy {
  @Output() pageChange = new EventEmitter<string>();
  @Output() showPatDetails = new EventEmitter();
  @Input('switchpage') switch: Subject<string>;
  currentPage ="Calendar";
  messageCount$ = new BehaviorSubject<number>(0);
  private destroy$ = new Subject<void>();
  private messagesSubscription: Subscription;

  constructor(
    private router: Router,
    public loginService: LoginService,
    public PatientsService: PatientsService,
    private http: HttpClient,
    private translate: TranslateService,
    public whatsappService: WhatsappService,
    public msgAppAccessService: msgAppAccessService,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.currentPage= this.isRouteActive('appointments/patient')? 'Patients':this.isRouteActive('appointments')?'Calendar':this.isRouteActive('questionnaires')?'questionnaires':this.isRouteActive('financial')?'Financial Report':'exams'

    if(this.switch){
      this.switch.subscribe((page)=>{
      this.currentPage=page
      })

    }
    if(this.loginService.premissions && this.loginService.premissions.hasMessagingApp) {
      timer(0, 2 * 60 * 1000)
      .pipe(
        switchMap(() => this.whatsappService.getAwaitingMsg()),
        takeUntil(this.destroy$)
      )
      .subscribe(
        (response:any) => {
          // 2. Push the new count into the stream
          this.messageCount$.next(response.MsgCount);
        },
        (error) => {
          console.error('Failed to get message count', error);
          this.messageCount$.next(0); // Push 0 on error
        }
      );
    // 3. This stream LISTENS for changes and plays the sound
    this.messageCount$
      .pipe(
        pairwise(), // Emits the [previous, current] value. Skips the first emission!
        skip(1),
        takeUntil(this.destroy$)
      )
      .subscribe(([previousCount, currentCount]) => {
        if (currentCount > previousCount) {
          this.playSound();
        }
      });
    }
  }

  
  setPage(page:string){
    this.currentPage=page;
    this.pageChange.emit(page);
  }

  
  isRouteActive(route: string): boolean {
    return this.router.url.includes(`/${route}`);
  
  }

  
  goBilling() {
    this.router.navigate(["/billing"]);
  }

  
  redirectAdministration() {
    const type = this.loginService.isCardio ? 'cardio' : this.loginService.isGastro ? 'gastro' : this.loginService.isEyes ? 'eyes' : this.loginService.isUSG ? 'usg' : 'aweb';
    this.http.post('/api/administration', {type}).subscribe((data: string) => {
      window.location.href = data;
    })
  }


  getButtonText(): string {
    let domainUrl = "";
    if (this.loginService.isCardio) {
      domainUrl = this.translate.instant('appointments.gui.labels.domains.Cardio');
    }
    if (this.loginService.isGastro) {
      domainUrl = this.translate.instant('appointments.gui.labels.domains.Gastro');
    }

    if (this.loginService.isEyes) {
      domainUrl = this.translate.instant('appointments.gui.labels.domains.Eyes');
    }
    if (this.loginService.isUSG) {
      domainUrl = this.translate.instant('appointments.gui.labels.domains.USG');
    }
    if (this.loginService.isObgyn) {
      domainUrl = this.translate.instant('appointments.gui.labels.domains.OBGYN');

    }
    return domainUrl;
  }

  openMsgApp() {
    this.msgAppAccessService.open(MessagingAppDialogComponent, {
      width: '80vw',
      height: '85vh',
      panelClass: 'iframe-dialog',
      hasBackdrop: false,
    });
  }
  restoreDialog(): void {
    this.msgAppAccessService.restore();
  }
  private playSound(): void {
    const audio = new Audio('assets/sounds/bell.mp3');
    audio.play();
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
